export default __webpack_public_path__ + "static/media/chevron-down_s.7eafd205.svg";